const TEXT_EDITOR_FONT_SIZES = [
    '12px', '14px', '16px',
    '18px', '20px', '22px',
    '24px', '26px', '28px',
    '30px', '32px', '34px',
    '36px', '38px', '40px',
    '42px', '44px', '46px',
    '48px', '50px', '52px',
];
const TEXT_EDITOR_THEME = 'snow';
/** Each different array here, represents a toolbar option group */
const TEXT_EDITOR_TOOLBAR_OPTIONS = [
    /** Font settings group */
    [{ font: [] }, { size: TEXT_EDITOR_FONT_SIZES }],
    /** Text formats and alignment group */
    ['bold', 'italic', { align: [] }, 'link'],
];
const TEXT_EDITOR_FORMATS = [
    'align',
    'bold',
    'bullet',
    'font',
    'italic',
    'link',
    'list',
    'size',
];
export { TEXT_EDITOR_FONT_SIZES, TEXT_EDITOR_FORMATS, TEXT_EDITOR_THEME, TEXT_EDITOR_TOOLBAR_OPTIONS, };
//# sourceMappingURL=text-editor-constants.js.map